import React from "react";
import "./FormationQuizz.scss";
import { useHistory, useRouteMatch } from "react-router-dom";
import { getModuleGroup, coursePreview } from "api/training";
import InsLoader from "components/InsLoader/InsLoader";
import Scorm from "components/Quizz/Scorm/Scorm";
import Header from "components/Quizz/Header/Header";
import Affinite from "components/Quizz/modules/Affinite/Affinite";
import QcmMultiple from "components/Quizz/modules/QcmMultiple/QcmMultiple";
import Qcm from "components/Quizz/modules/Qcm/Qcm";
import QcmPictures from "components/Quizz/modules/QcmPictures/QcmPictures";
import Content from "components/Quizz/modules/Content/Content";
import Video from "components/Quizz/modules/Video/Video";
import { useTranslation } from "react-i18next";

const FormationQuizz = () => {
  const router = useHistory();
  const match = useRouteMatch();
  const { i18n } = useTranslation();
  const isPreview = match.params.idPreview;
  const courseId = match.params.id;

  const [moduleGroup, setmoduleGroup] = React.useState();
  const [step, setstep] = React.useState(0);
  const [answers, setanswers] = React.useState([]);
  const [loading, setloading] = React.useState(true);

  const load = () => setloading(true);
  const stoploading = () => setloading(false);

  const handleRedirection = (error) => {
    console.log({ error });
    router.push("/");
  };

  const handleModuleEnd = () => {
    if (step === moduleGroup.modules.length - 1) {
      if (isPreview) {
        return router.push(`/course/preview/${moduleGroup.id}/result`);
      }

      router.push(`/formations/${courseId}/${moduleGroup.id}/result`);

      return;
    }

    setstep((step) => step + 1);
  };

  const handleAnswer = (isCorrect) => {
    setanswers((answers) => {
      const newAnswers = [...answers];

      if (!newAnswers[step]) {
        newAnswers[step] = [];
      }

      newAnswers[step].push(isCorrect);

      return newAnswers;
    });

    window.scroll(0, 0);
  };

  const _getModuleGroup = () => {
    const moduleGroupIdArray = match.params.moduleId.split("-");
    const moduleGroupId = moduleGroupIdArray[moduleGroupIdArray.length - 1];

    load();

    if (isPreview) {
      coursePreview(moduleGroupId)
        .then(setmoduleGroup)
        .catch(handleRedirection)
        .finally(stoploading);

      return;
    }

    getModuleGroup(moduleGroupId)
      .then(setmoduleGroup)
      .catch(handleRedirection)
      .finally(stoploading);
  };

  React.useEffect(() => {
    _getModuleGroup();
  }, [i18n.language]);

  React.useEffect(() => {
    console.log({ answers });
  }, [answers]);

  if (loading) {
    return (
      <div className="formation_desc">
        <InsLoader />
      </div>
    );
  }

  if (moduleGroup.type === "scorm") {
    return (
      <Scorm
        title={moduleGroup.course_name}
        scorm_path={moduleGroup.modules[0].scorm_path}
      />
    );
  }

  const currentModule = moduleGroup.modules[step];

  const currentModuleProps = {
    onModuleEnd: handleModuleEnd,
    onAnswer: handleAnswer,
    questions: currentModule.questions,
    moduleId: currentModule.id,
    isPreview: isPreview,
  };

  return (
    <div
      className={
        isPreview ? "quizz_wrapper quizz_wrapper_preview" : "quizz_wrapper"
      }
    >
      {!isPreview && <Header modules={moduleGroup.modules} answers={answers} />}
      <div className="title">{currentModule.course_name}</div>
      {currentModule.type === "trueFalse" && (
        <Affinite {...currentModuleProps} />
      )}
      {currentModule.type === "singleQuizz" && <Qcm {...currentModuleProps} />}
      {currentModule.type === "multipleQuizz" && (
        <QcmMultiple {...currentModuleProps} />
      )}
      {currentModule.type === "pictureQuizz" && (
        <QcmPictures {...currentModuleProps} />
      )}
      {currentModule.type === "content" && <Content {...currentModuleProps} />}
      {currentModule.type === "video" && <Video {...currentModuleProps} />}
    </div>
  );
};

export default FormationQuizz;
